export const PropertyTypes = {
  Apartment: 1,
  House: 2,
  Land: 3,
  Unit: 4,
  Townhouse: 5,
  DevelopmentSite: 6,
  Villa: 7,
  Flat: 8,
  Studio: 9,
  Warehouse: 10,
  DuplexSemiDetached: 11,
  Alpine: 12,
  AcreageSemiRural: 13,
  Retirement: 14,
  BlockOfUnits: 15,
  Terrace: 16,
  ServicedApartment: 18,
  Other: 19,
  SemiDetached: 20,
  SemiRural: 21,
  Duplex: 22,
  Condo: 23,
  SingleFam: 24,
  MultiFam: 25,
  Rural: 26,
} as const;

export type PropertyType = keyof typeof PropertyTypes;

export function isPropertyType(value: string): value is PropertyType {
  return value in PropertyTypes;
}

export interface PropertyTypeExtended {
  id: number;
  name: string;
  enum: PropertyType;
}

export function isPropertyTypeExtended(
  propertyType: PropertyType | { id: number; name: string; enum: PropertyType },
): propertyType is PropertyTypeExtended {
  // SAFETY(legacy): unreviewed, pre-dates this rule.
  return (propertyType as PropertyTypeExtended).enum !== undefined;
}

export const PROPERTY_TYPES_TRANSLATION_KEY = 'propertyTypes';
